import SettingFrame from "../../../../components/@settings/SettingFrame";
import NewCustomField from "../../../../components/@custom_fields/NewCustomField";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function CustomFieldNewPage() {

    let routeType = routeTypes.admin

    return (
        <SettingFrame
            routeType={routeType}
        >
            <NewCustomField
                routeType={routeType}
            />
        </SettingFrame>
    )
}       